.AdCreators {
  padding: 0 12px;
  max-width: 500px;
  transition: all 0.2s ease-in-out;

  .title {
    margin: 0 0 10px 8px;
    font: var(--font-heading-xs-bold);
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(auto, 1fr));
    gap: 8px;

    .withSnapFeed & {
      height: 70svh;
      grid-template-rows: repeat(2, 1fr);
    }
  }
}